import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard }     from './services/authguard.service';
import { AntiAuthGuard }     from './services/anti-authguard.service';
import { LoginComponent }   from './login/login.component';
import { CheckinComponent } from './checkin/checkin.component';
import { SignupComponent } from "app/signup/signup.component";
import {VisitorsComponent} from './visitors/visitors.component';

export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  { path: 'login', component: LoginComponent, canActivate: [AntiAuthGuard] },
  { path: 'checkin', component: CheckinComponent, canActivate: [AuthGuard] },
  { path: 'signup', component: SignupComponent, canActivate: [AuthGuard] },
  { path: 'visitors', component: VisitorsComponent, canActivate: [AuthGuard] }

];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts